import Lightning from '@lightningjs/sdk/src/Lightning';
import { Colors, Storage } from '@lightningjs/sdk';

//AuthRoute
import AuthRoute from '../../../../components/layouts/AuthRoute/AuthRoute';

let profileInfo;

export default class ProfilePicture extends AuthRoute {
  static _template() {
    return {
      Picture: {
        y: 355,
        x: 1430,
      },
      PictureBorder: { y: 355, x: 1430 },
    };
  }
  set profileId(val) {
    return (this._profileId = val);
  }

  _enable() {
    profileInfo = Storage.get('create-profile');
    this._PictureBorder.patch({
      texture: Lightning.Tools.getRoundRect(250, 250, 250 / 2, 5, Colors('#D6D6D7').get(), false),
    });
    this._Picture.patch({
      texture: {
        type: Lightning.textures.ImageTexture,
        src: profileInfo.profileImage,
        resizeMode: { type: 'cover', w: 253, h: 253 },
      },
      shader: {
        type: Lightning.shaders.RoundedRectangle,
        radius: 253 / 2,
      },
    });
  }
  get _Picture() {
    return this.tag('Picture');
  }
  get _PictureBorder() {
    return this.tag('PictureBorder');
  }
  set item({ action }) {
    return (this._item = { action });
  }
}
